import { useCallback, useEffect, useRef, useState } from 'react'
import s from './styles.module.scss'
import * as api from 'api'
import { Alert, ImageTag, Loader, NoData } from 'components'
import images from 'images'

const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST

export default function Main(props) {
  const [listing, setListing] = useState(null)
  const [loading, setLoading] = useState(false)
  const processing = useRef(false)
  const userData = JSON.parse(window.localStorage.getItem('userData'))

  const getListing = useCallback(async () => {
    if (processing.current) return
    processing.current = true
    setLoading(true)

    const fetchListing = await api.publicApi.listings.fetch({
      id: props.id
    })

    if (fetchListing.code === 200) {
      setListing(fetchListing.payload.getListing)
    } else if (fetchListing.code === 400) {
      Alert.error('Offering not found')
    }
    processing.current = false
    setLoading(false)
  }, [props.id])

  useEffect(() => {
    if (props.id) getListing()
  }, [props.id, getListing])

  const updateNotificationAndViews = useCallback(async () => {
    if (processing.current) return
    processing.current = true

    const sendNotification = await api.publicApi.notifications.create({
      notification: listing.listingName + " is catching people's attention",
      fkUserId: listing.fkUserId,
      redirect: ''
    })

    if (sendNotification.code !== 201) {
      Alert.error(sendNotification.message)
    }

    const updateViews = await api.publicApi.listings.updateViews({
      fkListingId: listing._id
    })

    if (updateViews.code !== 201) {
      Alert.error(updateViews.message)
    }

    processing.current = false
  }, [listing])

  useEffect(() => {
    if (listing) updateNotificationAndViews()
  }, [listing, updateNotificationAndViews])

  useEffect(() => {
    const listingImages = (listing?.images || []).filter(Boolean)
    if (listingImages.length > 1) {
      new window.Swiper('.mySwiper1', {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    }
  }, [listing])

  const queryHandler = async (id = '', fkUserId = '', query = '') => {
    if (processing.current) return
    processing.current = true

    const createLead = await api.publicApi.leads.create({
      contactPerson: userData.name,
      phoneNo: userData.phoneNo,
      email: userData.email,
      query,
      state: userData.state,
      city: userData.city,
      fkListingId: id
    })

    if (createLead.code === 201) {
      await api.publicApi.notifications.create({
        notification: 'New query from ' + userData.name + ' ' + query,
        fkUserId,
        redirect: ''
      })
      Alert.success('Your interest has been sent!')
    }

    processing.current = false
  }

  const listingImages = (listing?.images || []).filter(Boolean)
  const phoneNo = listing?.phoneNo

  return (
    <div className={s.main}>
      <button type='button' className={s.close} onClick={props.onCloseModal} aria-label='Close'>
        <span className='material-icons-outlined'>close</span>
      </button>

      <div className={s.viewListing}>
        {loading && (
          <div className={s.loader}>
            <Loader color='var(--c-primary)' colorText='var(--c-primary)' />
          </div>
        )}

        {!loading && listing && (
          <div className={s.viewListingInner + ' innerScroll'}>
            <div className={s.listingImages}>
              {listingImages.length > 1 ? (
                <div className='swiper mySwiper1'>
                  <div className='swiper-wrapper'>
                    {listingImages.map((image, i) => (
                      <div className={s.slide + ' swiper-slide'} key={i}>
                        <ImageTag src={IMAGE_HOST + image} alt={listing.listingName} />
                      </div>
                    ))}
                  </div>
                  <div className='swiper-button-next'></div>
                  <div className='swiper-button-prev'></div>
                  <div className='swiper-pagination'></div>
                </div>
              ) : listingImages.length === 1 ? (
                <div className={s.slide}>
                  <ImageTag src={IMAGE_HOST + listingImages[0]} alt={listing.listingName} />
                </div>
              ) : (
                <div className={s.noImage}>
                  <span className='material-icons-outlined'>image_not_supported</span>
                  <span>No image available</span>
                </div>
              )}
            </div>

            <div className={s.content}>
              <h2 className={s.title}>{listing.listingName}</h2>
              {listing.businessName && <p className={s.businessName}>~{listing.businessName}</p>}

              <div className={s.infoGrid}>
                {phoneNo && (
                  <div className={s.infoCard}>
                    <span className={s.infoLabel}>Contact No.</span>
                    <span className={s.infoValue}>+91 {phoneNo}</span>
                  </div>
                )}
                {listing.address && (
                  <div className={s.infoCard}>
                    <span className={s.infoLabel}>Address</span>
                    <span className={s.infoValue}>
                      <span className='material-icons-outlined'>location_on</span>
                      {listing.address}
                    </span>
                  </div>
                )}
              </div>

              {listing.description && (
                <div className={s.adInfo}>
                  <span className={s.infoLabel}>Description</span>
                  <p>{listing.description}</p>
                </div>
              )}

              {phoneNo && (
                <div className={s.actions}>
                  <button
                    type='button'
                    className={s.callBtn}
                    onClick={async () => {
                      if (userData) await queryHandler(props.id, listing.fkUserId, 'Queried via call!!')
                      window.location.href = `tel:+91-${phoneNo}`
                    }}
                  >
                    <span className='material-icons-outlined'>call</span>
                    Call Us
                  </button>
                  <button
                    type='button'
                    className={s.whatsappBtn}
                    onClick={async () => {
                      if (userData) await queryHandler(props.id, listing.fkUserId, 'Queried via whatsapp!!')
                      window.open('https://wa.me/91' + phoneNo, '_blank')
                    }}
                  >
                    <img src={images.whatsapp} alt='' />
                    WhatsApp
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {!loading && !listing && (
          <div className={s.noData}>
            <NoData />
          </div>
        )}
      </div>
    </div>
  )
}
